import { useContext, useMemo } from 'react';
import { createContext } from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
export const ControlContext = /*#__PURE__*/createContext(undefined);
export const ControlProvider = ({
  isControl,
  children
}) => {
  const contextValue = useMemo(() => ({
    isControl
  }), [isControl]);
  return /*#__PURE__*/_jsx(ControlContext.Provider, {
    value: contextValue,
    children: children
  });
};
export const useControlContext = () => {
  return useContext(ControlContext);
};